import { getInfo, checkBannedFunction } from '@/api/index'
import { getToken, removeToken, getVisitorToken } from '@/utils/auth'

const info = localStorage.getItem('info')
const invitationSource = localStorage.getItem('invitationSource')
const isLogin = function() {
  // 通过对比token 且 是否时登录状态 来判断是否登录
  return getToken() && getToken() !== getVisitorToken() && localStorage.getItem('isLogin') === '1'
}

const user = {
  state: {
    token: getToken(),
    //用户信息
    info: info ? JSON.parse(info) : {},
    //角色类型
    subjectType: localStorage.getItem('subjectType') || '',
    //展会id
    exhibitionId: localStorage.getItem('exhibitionId') || '',
    //语言
    language: localStorage.getItem('language') || 'zh',
    //存储之前的本地语言
    languageOld: localStorage.getItem('languageOld') || localStorage.getItem('language') || 'zh',
    //用户名
    name: localStorage.getItem('name') || '--',
    //展商id
    exhibitorId: localStorage.getItem('exhibitorId') || '',
    //观众id
    visitorId: localStorage.getItem('visitorId') || '',
    //登录状态
    isLogin: isLogin(),
    //来源
    fromUrl: localStorage.getItem('fromUrl') || '',
    //邀请函来源
    invitationSource: invitationSource ? JSON.parse(invitationSource) : null,
    //广告位分享来源的地址
    advertisingSharing: localStorage.getItem('advertisingSharing') || '',
    // 邀约时弹出提示
    inviteType: sessionStorage.getItem('inviteType') || '',
    // 展商禁止访问页面权限列表
    checkBannedList: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INFO: (state, info) => {
      state.info = info || {}
      if (!info) {
        localStorage.removeItem('info')
      } else {
        localStorage.setItem('info', JSON.stringify(info))
      }
    },
    SET_NAME: (state, name) => {
      state.name = name
      if (!name) {
        localStorage.removeItem('name')
      } else {
        localStorage.setItem('name', name)
      }
    },
    SET_SUBJECTTYPE: (state, subjectType) => {
      state.subjectType = subjectType
      if (!subjectType) {
        localStorage.removeItem('subjectType')
      } else {
        localStorage.setItem('subjectType', subjectType)
      }
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      localStorage.setItem('language', language)
    },
    SET_LANGUAGE_OLD: (state, language) => {
      state.languageOld = language
      localStorage.setItem('languageOld', language)
    },
    SET_EXHIBITIONID: (state, exhibitionId) => {
      state.exhibitionId = exhibitionId
      if (!exhibitionId) {
        localStorage.removeItem('exhibitionId')
      } else {
        localStorage.setItem('exhibitionId', exhibitionId)
      }
    },
    SET_EXHIBITORID: (state, exhibitorId) => {
      state.exhibitorId = exhibitorId
      if (!exhibitorId) {
        localStorage.removeItem('exhibitorId')
      } else {
        localStorage.setItem('exhibitorId', exhibitorId)
      }
    },
    SET_VISITORID: (state, visitorId) => {
      state.visitorId = visitorId
      if (!visitorId) {
        localStorage.removeItem('visitorId')
      } else {
        localStorage.setItem('visitorId', visitorId)
      }
    },
    SET_ISLOGIN: (state, isLogin) => {
      if (isLogin !== '1') {
        state.isLogin = false
        localStorage.removeItem('isLogin')
      } else {
        state.isLogin = true
        localStorage.setItem('isLogin', '1')
      }
    },
    SET_FROMURL: (state, fromUrl) => {
      state.fromUrl = fromUrl
      if (!fromUrl) {
        localStorage.removeItem('fromUrl')
      } else {
        localStorage.setItem('fromUrl', fromUrl)
      }
    },
    SET_INVITATION_SOURCE: (state, invitationSource) => {
      state.invitationSource = invitationSource
      if (!invitationSource) {
        localStorage.removeItem('invitationSource')
      } else {
        localStorage.setItem('invitationSource', JSON.stringify(invitationSource))
      }
    },
    SET_ADVERTISING_SHARING: (state, advertisingSharing) => {
      state.advertisingSharing = advertisingSharing
      if (!advertisingSharing) {
        localStorage.removeItem('advertisingSharing')
      } else {
        localStorage.setItem('advertisingSharing', advertisingSharing)
      }
    },
    SET_INVITETYPE(state,data){
      state.inviteType = data
    },
    SET_CHECKBANNEDLIST(state, data) {
      state.checkBannedList = data || {}
    }
  },

  actions: {
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token)
          .then(res => {
            const info = res.user
            if (res.subjectType) {
              commit('SET_SUBJECTTYPE', res.roles)
            }
            commit('SET_INFO', info)
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // 获取展商权益中被禁用功能
    GetCheckBannedList({ commit }) {
        return new Promise((resolve, reject) => {
            checkBannedFunction()
              .then(res => {
                return res.data
              })
              .then(res => {
                commit('SET_CHECKBANNEDLIST', res.data)
                resolve(res)
              })
              .catch(error => {
                reject(error)
              })
          })
    },

    // 退出系统
    LogOut({ dispatch, rootState }) {
      return new Promise(resolve => {
        dispatch('ClearUserStore')
        if (rootState.sendingUser) {
          dispatch('chatLogout')
        }
        removeToken()
        sessionStorage.clear()
        resolve()
      })
    },

    // 清空所有有关的user信息
    ClearUserStore: ({ commit }) => {
      commit('SET_TOKEN', '')
      // commit('SET_SUBJECTTYPE', '')
      commit('SET_INFO', null)
      commit('SET_NAME', '')
      commit('SET_EXHIBITORID', '')
      commit('SET_VISITORID', '')
      commit('SET_ISLOGIN', '')
      commit('SET_CONFIGSWITCH', '')
      commit('setTouristService', null)
      // commit('SET_FROMURL', '')
      // commit('SET_INVITATION_SOURCE', null)
      // commit('SET_ADVERTISING_SHARING', '')
      commit('SET_LOGIN_TYPE', '')
      commit('SET_LOGIN_ACCOUNT', '')
    },

    // 登录成功后设置信息
    BaseInfo({ commit, state }, data) {
      commit('SET_INFO', data.exhibitionUserRegister)
      commit('SET_SUBJECTTYPE', data.exhibitionUserRegister.subjectType)
      commit('SET_EXHIBITIONID', data.exhibitionUserRegister.exhibitionId)
      commit('SET_ISLOGIN', '1')
      if (state.subjectType == 'ACTOR') {
        commit('SET_NAME', data.exhibitionUserRegister.userInfo.name)
        commit('SET_EXHIBITORID', data.exhibitionUserRegister.exhibitorEmployee.exhibitorId)
      } else {
        commit('SET_NAME', data.exhibitionUserRegister.visitor.name)
        commit('SET_VISITORID', data.exhibitionUserRegister.visitor.id)
      }
    }
  }
}

export default user
